// src/features/selectedVisit/selectedVisitSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { VisitListSerializer } from "@/types/visit"

interface SelectedVisitState {
  visit: VisitListSerializer | null
}

const initialState: SelectedVisitState = {
  visit: null,
}

const selectedVisitSlice = createSlice({
  name: "selectedVisit",
  initialState,
  reducers: {
    setSelectedVisit(state, action: PayloadAction<VisitListSerializer>) {
      state.visit = action.payload
    },
    clearSelectedVisit(state) {
      state.visit = null
    },
  },
})

export const { setSelectedVisit, clearSelectedVisit } = selectedVisitSlice.actions
export default selectedVisitSlice.reducer
